import TagManager from 'react-gtm-module';

import { CORE_DEVELOPMENT, CORE_PRODUCTION } from 'core/constants';
import WebStorage from 'core/services/WebStorage';
import CORE_SETTINGS from 'core/settings';
import { getStorageUserId } from 'utils/storage';
import { GTM_EVENT_ERROR_DATA } from 'utils/analytics/gtmLabel';

export enum GTMActions {
  USER_REGISTER_FUNNEL = 'TAG_MANAGER/USER_REGISTER_FUNNEL',
  USER_AUTHORIZATION = 'TAG_MANAGER/USER_AUTHORIZATION',
  USER_INFO = 'TAG_MANAGER/USER_INFO',
  CHANGE_PHONE = 'TAG_MANAGER/CHANGE_PHONE',
  PAYMENT = 'TAG_MANAGER/PAYMENT',
  REQUEST = 'TAG_MANAGER/REQUEST',
  CHANGE_CONDITIONS = 'TAG_MANAGER/CHANGE_CONDITIONS',
  REGISTRATION = 'TAG_MANAGER/REGISTRATION',
  SITE_ACTIONS = 'TAG_MANAGER/SITE_ACTIONS',
  PAGE_VIEW = 'TAG_MANAGER/PAGE_VIEW',
  SEND_USER_ID = 'TAG_MANAGER/SEND_USER_ID',
  NOT_FOUND_PAGE = 'TAG_MANAGER/NOT_FOUND_PAGE',
  OTP_REQUEST = 'TAG_MANAGER/OTP_REQUEST',
}

export const initialiseGTM = () => {
  if (CORE_SETTINGS.environment !== CORE_PRODUCTION) return;
  // if (CORE_SETTINGS.environment !== CORE_DEVELOPMENT) return;

  const tagManagerArgs = {
    gtmId: CORE_SETTINGS.gtmId,
    dataLayerName: 'dataLayer',
  };
  if (!Boolean(WebStorage.getLocalStorage('admin'))) TagManager.initialize(tagManagerArgs);
};

export const sendDataLayer = (
  eventName: string,
  label: string,
  type?: string,
  UID: number = getStorageUserId(),
  application_id?: string | number,
  reason: string | null = null,
  status: string | null = null
): void => {
  const tagManagerArgs = {
    dataLayer: {
      event: eventName,
      label,
      type,
      UID,
      application_id,
      reason,
      status,
    },
  };

  // if (CORE_SETTINGS.environment === CORE_DEVELOPMENT) {
  //   // eslint-disable-next-line no-console
  //   console.log('TagManager.dataLayer=', tagManagerArgs);
  //   return;
  // }

  TagManager.dataLayer(tagManagerArgs);
};

export const sendDataLayerError = (
  label: string,
  stage: string,
  UID: number,
  field_name: string,
  error_text: string
): void => {
  const tagManagerArgs = {
    dataLayer: {
      event: GTM_EVENT_ERROR_DATA,
      label,
      stage,
      UID,
      field_name,
      error_text,
    },
  };

  // if (CORE_SETTINGS.environment === CORE_DEVELOPMENT) {
  //   // eslint-disable-next-line no-console
  //   console.log('TagManager.dataLayer=', tagManagerArgs);
  //   return;
  // }

  TagManager.dataLayer(tagManagerArgs);
};
